import { render } from "./LandingPageComponent.vue?vue&type=template&id=ecb24dce"
import script from "./LandingPageComponent.vue?vue&type=script&lang=js"
export * from "./LandingPageComponent.vue?vue&type=script&lang=js"

import "./LandingPageComponent.vue?vue&type=style&index=0&id=ecb24dce&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__